import React from 'react';
import './Loader.css';
const loader = (props) =>{
    return (
        <div className='LdsRing'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}
export default loader;


// WEBPACK FOOTER //
// ./src/Components/UI/Loader/Loader.js